import React, { FC, ReactElement } from 'react';

import { Redirect } from 'react-router-dom';

import { useUserData } from 'context';
import { IRoute, PATHS } from 'types';
import { RouteContent } from 'views/components/RouteContent/RouteContent';

const PublicRoute: FC<IRoute> = ({ component, pageTitle }): ReactElement => {
  const { user } = useUserData();

  return user ? (
    <Redirect to={PATHS.ROOT} />
  ) : (
    <>
      <RouteContent component={component} pageTitle={pageTitle} />
    </>
  );
};

export { PublicRoute };
